import type { ReactNode } from 'react';
import styles from './SelectionCard.module.css';

export interface SelectionCardProps {
	name: string;
	location?: string;
	farmInfo?: string;
	avatar?: ReactNode;
	icon?: ReactNode;
	locationIcon?: ReactNode;
	farmIcon?: ReactNode;
	selected?: boolean;
	onClick?: () => void;
}

export const SelectionCard = ({
	name,
	location,
	avatar,
	icon,
	locationIcon,
	farmInfo,
	farmIcon,
	selected = false,
	onClick,
}: SelectionCardProps) => {
	return (
		<button
			type="button"
			className={`${styles.card} ${selected ? styles.selected : ''}`}
			onClick={onClick}
		>
			<div className={styles.visual}>
				{avatar || icon || <div className={styles.fallback}>{name.charAt(0)}</div>}
			</div>
			<div className={styles.info}>
				<span className={styles.name}>{name}</span>
				{location && (
					<div className={styles.locationContainer}>
						<span>{locationIcon}</span> <span className={styles.location}>{location}</span>
					</div>
				)}
				{farmInfo && (
					<div className={styles.farmInfoContainer}>
						<span>{farmIcon}</span>
						<span className={styles.farmInfo}>{farmInfo}</span>
					</div>
				)}
			</div>
		</button>
	);
};
